import nodeApi from '../utils/nodeApiClient';

const billCyclesApi = {
  list: () => nodeApi.get('/bill-cycles')
};

export default billCyclesApi;
